import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import {provideCharts,withDefaultRegisterables} from 'ng2-charts';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiInterceptor } from './core/interceptors/api-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
  
    provideRouter(routes),

     provideCharts(
      withDefaultRegisterables()
    ),
    provideHttpClient(
      withInterceptors([apiInterceptor]) 
    ),
  ]
};
